var RenderBlock = /** @class */ (function () {
    function RenderBlock() {
        this.props = {};
    }
    RenderBlock.prototype.activate = function (model) {
        if (model) {
            this.host = model.host;
            this.props = model.props || {};
        }
    };
    return RenderBlock;
}());
export { RenderBlock };
